<template>
  <div class="optional-buttons">
    <IconBoxZzimWithApi
      :section="contentType"
      :content-id="contentId"
      :zzim="isLikeOn"
    />
    <IconBoxSnsShare :content-info="contentInfo" :section="contentType" />
  </div>
</template>
<script setup>
  import { computed, defineProps, defineEmits } from 'vue'
  import IconBoxSnsShare from '@/components/play/IconBoxSnsShare.vue'
  import IconBoxZzimWithApi from '@/components/play/IconBoxZzimWithApi.vue'

  const props = defineProps({
    contentInfo: {
      type: Object,
      default: () => {},
    },
    contentType: {
      type: String,
      default: '',
    },
  })

  defineEmits(['on-click-share', 'on-click-download'])

  const isMovie = computed(() => props.contentType === 'movie')
  const movieId = computed(() => props.contentInfo?.movieid ?? '')
  const programId = computed(() => props.contentInfo?.programid ?? '')
  const contentId = computed(
    () => (isMovie.value ? movieId.value : programId.value) ?? '',
  )
  const isLikeOn = computed(() => props.contentInfo?.zzim.toLowerCase() ?? 'n')
</script>
